import { Circle, Grid } from 'react-feather';

// permission modules
import modules from '@src/service/modules';

export default [
    {
        id: 'master',
        title: 'Master',
        icon: <Grid size={20} />,
        children: [
            {
                id: 'items',
                title: 'Items',
                icon: <Circle size={20} />,
                children: [
                    {
                        id: 'item-category',
                        title: 'Category',
                        icon: <Circle size={20} />,
                        navLink: '/master/category/item'
                    },
                    {
                        id: 'item-sub-category',
                        title: 'Subcategory',
                        icon: <Circle size={20} />,
                        navLink: '/master/subcategory/item'
                    },
                    {
                        id: 'item',
                        title: 'Item',
                        icon: <Circle size={20} />,
                        navLink: '/master/item'
                    }
                ]
            },
            {
                id: 'materials',
                title: 'Materials',
                icon: <Circle size={20} />,
                children: [
                    {
                        id: 'material-category',
                        title: 'Material',
                        icon: <Circle size={20} />,
                        navLink: '/master/category/material'
                    },
                    {
                        id: 'material-sub-category',
                        title: 'Material',
                        icon: <Circle size={20} />,
                        navLink: '/master/subcategory/material'
                    },
                    {
                        id: 'material',
                        title: 'Material',
                        icon: <Circle size={20} />,
                        navLink: '/master/material'
                    }
                ]
            },
            {
                id: 'structure',
                title: 'Structure',
                icon: <Circle size={20} />,
                children: [
                    {
                        id: 'structure-type',
                        title: 'Type',
                        icon: <Circle size={20} />,
                        navLink: '/master/structure/type'
                    },
                    {
                        id: 'structure-activity',
                        title: 'Activity',
                        icon: <Circle size={20} />,
                        navLink: '/master/structure/activity'
                    }
                ]
            },
            {
                id: 'mixDesign',
                title: 'Mix Design',
                icon: <Circle size={20} />,
                navLink: '/master/mix-design'
            },
            {
                id: 'vandor-supplier',
                title: 'Vandor/Supplier',
                icon: <Circle size={20} />,
                navLink: '/master/supplier'
            },
            {
                id: 'brand',
                title: 'Brand',
                icon: <Circle size={20} />,
                navLink: '/master/brand'
            },
            {
                id: 'unit',
                title: 'Unit',
                icon: <Circle size={20} />,
                navLink: '/master/unit'
            },
            {
                id: 'machinery',
                title: 'Machinery',
                icon: <Circle size={20} />,
                children: [
                    {
                        id: 'machinery-type',
                        title: 'Type',
                        icon: <Circle size={20} />,
                        navLink: '/master/machinery-type'
                    },
                    {
                        id: 'machinies',
                        title: 'Machineries',
                        icon: <Circle size={20} />,
                        navLink: '/master/machinies'
                    }
                ]
            },
            {
                id: 'adjustment',
                title: 'Adjustment Type',
                icon: <Circle size={20} />,
                navLink: '/master/adjustment'
            },
            {
                id: 'form',
                title: 'Form',
                icon: <Circle size={20} />,
                navLink: '/master/forms'
            }
        ]
    }
];
